import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { ClientMeasure } from "../domain/client-measure";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";

@Injectable({
    providedIn: 'root',
})
export class ClientMeasureService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/clientMeasure`;

    constructor(public http: HttpClient,
        protected coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected router: Router) {
        super(router, coreData, snackBare);
    }

    getOrderableMeasureList(strategyId: number) {

        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${strategyId}/orderable`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getOrderableMeasure')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: ClientMeasure[]) => {
                return response.map((item: ClientMeasure) => {
                    return ClientMeasure.mapFromJSON(item);
                });
            }));
    }

    getOrderedMeasureList(strategyId: number) {

        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${strategyId}/ordered`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getOrderedMeasure')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: ClientMeasure[]) => {
                return response.map((item: ClientMeasure) => {
                    return ClientMeasure.mapFromJSON(item);
                });
            }));
    }

    getGenericList() {

        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/generic`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getGenericList')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: ClientMeasure[]) => {
                return response.map((item: ClientMeasure) => {
                    return ClientMeasure.mapFromJSON(item);
                });
            }));
    }

    preOrderSampling(samplingId: number) {
        this.loadingTask.activateLoading();
        return this.http.put(`${this.serviceUrl}/preorder/${samplingId}`, null, this.generateHeader()).pipe(
            catchError(this.handleError<any>('preOrderSampling')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }

    // getLastOrderedRecurrent(strategyId: number) {

    //     this.loadingTask.activateLoading();
    //     return this.http.get(`${this.serviceUrl}/${strategyId}/lastOrderedRecurrent`, this.generateHeader()).pipe(
    //         catchError(this.handleError<any>('lastOrderedRecurrent')),
    //         finalize(() => this.loadingTask.deactivateLoading()),
    //         map((response: ClientMeasure[]) => {
    //             return response.map((item: ClientMeasure) => {
    //                 return ClientMeasure.mapFromJSON(item);
    //             });
    //         }));
    // }
}